<script setup>
import { useUtilityStore } from "../store/UtililityStore";
import { useProductStore } from "../store/ProductStore";
import WelcomeProducts from "./WelcomeProducts.vue";
import { useUserStore } from "~/store/UserStore";
const { t } = useI18n();
const productStore = useProductStore();
const utilityStore = useUtilityStore();
const userStore = useUserStore();

const selectedLanguage = computed(() => utilityStore.selectedLanguage);
const products = computed(() => productStore.welcomProducts);
const backOrders = computed(() => productStore.backOrders);
const isAuthenticated = computed(() => userStore.isAuthenticated);
// Personalized carousel: only shown when enough recommendations survive the
// visibility/pricing resolution — a 2-3 item "personalized" row looks broken.
const recommendedProducts = computed(() =>
  productStore.recommendedProducts.length >= 5 ? productStore.recommendedProducts : []
);

// Section order + sorting follow issue #22 (Homepage Landing Page Remodeling):
// TCG, Video Games, Merchandising, IT & Accessories, Promo, Last Units — all Creation Date DESC.
const keys = ref([
  {
    key: "fresh_drops_tcg", "attribute": {},

    "categories": [
      "cld_353",
      "cld_360",
      "cld_356",
      "cld_362",
      "disney_lorcana_tcg",
      "TCG_accessories_B2B",
      "cld_900"
    ],
    expandedCategoryFilters: { "cld_266": true },
    categoryfilterState: { "parent": { "cld_266": { "value": true, "show": true } }, "child": { "all": true }, "grandchild": { "cld_353": { "value": true, "show": true, "key": "cld_353" }, "cld_360": { "value": true, "show": true, "key": "cld_360" }, "cld_356": { "value": true, "show": true, "key": "cld_356" }, "cld_362": { "value": true, "show": true, "key": "cld_362" }, "disney_lorcana_tcg": { "value": true, "show": true, "key": "disney_lorcana_tcg" }, "TCG_accessories_B2B": { "value": true, "show": true, "key": "TCG_accessories_B2B" }, "cld_900": { "value": true, "show": true, "key": "cld_900" } } },
    "release": {},
    sort: 'arrival_desc'
  },
  {
    key: "upcoming_gaming_releases",
    attribute: {
      "status_preorder": {
        "status preorder": true
      }
    },
    "categories": [
      "cld_800",
      "cld_799",
      "cld_798",
      "cld_868",
      "cld_866",
      "cld_865",
      "cld_774",
      "cld_539",
      "cld_587",
      "cld_773",
      "cld_870",
      "cld_871",
      "cld_894",
      "cld_893",
      "cld_898",
      "cld_897",
      "cld_896",
      "cld_875",
      "cld_874",
      "cld_780",
      "cld_861",
      "cld_860",
      "cld_681",
      "cld_682",
      "cld_685",
      "cld_791",
      "cld_748",
      "cld_818",
      "cld_824",
      "cld_902",
      "cld_198"
    ],
    "release": {},
    expandedCategoryFilters: { "cld_564": true },
    categoryfilterState: { "parent": { "cld_564": { "value": true, "show": true } }, "child": { "cld_797": { "value": true, "show": true }, "cld_863": { "value": true, "show": true }, "cld_537": { "value": true, "show": true }, "cld_585": { "value": true, "show": true }, "cld_864": { "value": true, "show": true }, "cld_892": { "value": true, "show": true }, "cld_895": { "value": true, "show": true }, "cld_8": { "value": true, "show": true }, "cld_873": { "value": true, "show": true }, "cld_859": { "value": true, "show": true }, "cld_680": { "value": true, "show": true }, "all": true }, "grandchild": { "cld_800": { "value": true, "show": true, "key": "cld_800" }, "cld_799": { "value": true, "show": true, "key": "cld_799" }, "cld_798": { "value": true, "show": true, "key": "cld_798" }, "cld_868": { "value": true, "show": true, "key": "cld_868" }, "cld_866": { "value": true, "show": true, "key": "cld_866" }, "cld_865": { "value": true, "show": true, "key": "cld_865" }, "cld_774": { "value": true, "show": true, "key": "cld_774" }, "cld_539": { "value": true, "show": true, "key": "cld_539" }, "cld_587": { "value": true, "show": true, "key": "cld_587" }, "cld_773": { "value": true, "show": true, "key": "cld_773" }, "cld_870": { "value": true, "show": true, "key": "cld_870" }, "cld_871": { "value": true, "show": true, "key": "cld_871" }, "cld_894": { "value": true, "show": true, "key": "cld_894" }, "cld_893": { "value": true, "show": true, "key": "cld_893" }, "cld_898": { "value": true, "show": true, "key": "cld_898" }, "cld_897": { "value": true, "show": true, "key": "cld_897" }, "cld_896": { "value": true, "show": true, "key": "cld_896" }, "cld_780": { "value": true, "show": true, "key": "cld_780" }, "cld_875": { "value": true, "show": true, "key": "cld_875" }, "cld_874": { "value": true, "show": true, "key": "cld_874" }, "cld_861": { "value": true, "show": true, "key": "cld_861" }, "cld_860": { "value": true, "show": true, "key": "cld_860" }, "cld_681": { "value": true, "show": true, "key": "cld_681" }, "cld_685": { "value": true, "show": true, "key": "cld_685" }, "cld_682": { "value": true, "show": true, "key": "cld_682" }, "cld_791": { "value": true, "show": true, "key": "cld_791" }, "cld_818": { "value": true, "show": true, "key": "cld_818" }, "cld_748": { "value": true, "show": true, "key": "cld_748" }, "cld_902": { "value": true, "show": true, "key": "cld_902" }, "cld_198": { "value": true, "show": true, "key": "cld_198" } } },
    sort: 'arrival_desc'
  },
  {
    key: "new_merchandising_collection", "attribute": {},

    "categories": [
      "cld_242",
      "cld_833",
      "cld_688",
      "cld_761",
      "cld_763",
      "cld_755",
      "cld_757",
      "cld_832",
      "cld_244",
      "cld_762",
      "cld_243",
      "cld_831",
      "cld_759",
      "cld_758",
      "cld_756",
      "cld_764",
      "cld_816",
      "cld_830"
    ],
    expandedCategoryFilters: { "cld_206": true },
    categoryfilterState: { "parent": { "cld_206": { "value": true, "show": true } }, "child": { "all": true }, "grandchild": { "cld_242": { "value": true, "show": true, "key": "cld_242" }, "cld_833": { "value": true, "show": true, "key": "cld_833" }, "cld_688": { "value": true, "show": true, "key": "cld_688" }, "cld_761": { "value": true, "show": true, "key": "cld_761" }, "cld_763": { "value": true, "show": true, "key": "cld_763" }, "cld_755": { "value": true, "show": true, "key": "cld_755" }, "cld_757": { "value": true, "show": true, "key": "cld_757" }, "cld_832": { "value": true, "show": true, "key": "cld_832" }, "cld_244": { "value": true, "show": true, "key": "cld_244" }, "cld_762": { "value": true, "show": true, "key": "cld_762" }, "cld_243": { "value": true, "show": true, "key": "cld_243" }, "cld_831": { "value": true, "show": true, "key": "cld_831" }, "cld_759": { "value": true, "show": true, "key": "cld_759" }, "cld_758": { "value": true, "show": true, "key": "cld_758" }, "cld_756": { "value": true, "show": true, "key": "cld_756" }, "cld_764": { "value": true, "show": true, "key": "cld_764" }, "cld_816": { "value": true, "show": true, "key": "cld_816" }, "cld_830": { "value": true, "show": true, "key": "cld_830" } } },
    "release": {},
    sort: 'arrival_desc'
  },
  {
    key: "new_it_accessories", "attribute": {},

    "categories": [
      "cld_510",
      "cld_497",
      "cld_459",
      "cld_503",
      "cld_499",
      "cld_807",
      "cld_460",
      "cld_512",
      "cld_627",
      "cld_501",
      "cld_629",
      "cld_498",
      "cld_625",
      "cld_573",
      "cld_793",
      "cld_534",
      "cld_504",
      "cld_572",
      "cld_577",
      "cld_508",
      "cld_506",
      "cld_511",
      "cld_513",
      "cld_575",
      "cld_626",
      "cld_639",
      "cld_792"
    ],
    expandedCategoryFilters: { "cld_387": true },
    categoryfilterState: { "parent": { "cld_387": { "value": true, "show": true } }, "child": { "all": true }, "grandchild": { "cld_510": { "value": true, "show": true, "key": "cld_510" }, "cld_497": { "value": true, "show": true, "key": "cld_497" }, "cld_459": { "value": true, "show": true, "key": "cld_459" }, "cld_503": { "value": true, "show": true, "key": "cld_503" }, "cld_499": { "value": true, "show": true, "key": "cld_499" }, "cld_807": { "value": true, "show": true, "key": "cld_807" }, "cld_460": { "value": true, "show": true, "key": "cld_460" }, "cld_512": { "value": true, "show": true, "key": "cld_512" }, "cld_627": { "value": true, "show": true, "key": "cld_627" }, "cld_501": { "value": true, "show": true, "key": "cld_501" }, "cld_629": { "value": true, "show": true, "key": "cld_629" }, "cld_498": { "value": true, "show": true, "key": "cld_498" }, "cld_625": { "value": true, "show": true, "key": "cld_625" }, "cld_573": { "value": true, "show": true, "key": "cld_573" }, "cld_793": { "value": true, "show": true, "key": "cld_793" }, "cld_534": { "value": true, "show": true, "key": "cld_534" }, "cld_504": { "value": true, "show": true, "key": "cld_504" }, "cld_572": { "value": true, "show": true, "key": "cld_572" }, "cld_577": { "value": true, "show": true, "key": "cld_577" }, "cld_508": { "value": true, "show": true, "key": "cld_508" }, "cld_506": { "value": true, "show": true, "key": "cld_506" }, "cld_511": { "value": true, "show": true, "key": "cld_511" }, "cld_513": { "value": true, "show": true, "key": "cld_513" }, "cld_575": { "value": true, "show": true, "key": "cld_575" }, "cld_626": { "value": true, "show": true, "key": "cld_626" }, "cld_639": { "value": true, "show": true, "key": "cld_639" }, "cld_792": { "value": true, "show": true, "key": "cld_792" } } },
    "release": {},
    sort: 'arrival_desc'
  },
  {
    key: 'promos', attribute: {
      price_promo: {
        "price promo": true,
      },
      "in_stock": {
        "in stock": true
      }
    },
    categories: [],
    expandedCategoryFilters: null,
    categoryfilterState: null,
    sort: 'arrival_desc'
  },
  // { key: 'best_sale', attribute: {} },
  {
  key: 'last_unit',
  attribute: {

    "stock_rank": {
      [t('products.stock_rank')]: true
    }
  },
    categories: [],
    expandedCategoryFilters: null,
    categoryfilterState: null,
    sort: 'arrival_desc'
  },

  // { key: 'new_arrivals', attribute: {} },
  // {
  //   key: 'incoming_release', attribute: {
  //     "status preorder": true,
  //     // Arriving soon : Product status = Preorder and shipments are underway
  //     // TODO We don't have this data in ES yet so we need to sync it
  //   }
  // },
  //  {
  //     key: 'new_announce', attribute: {
  //       "status preorder": true
  //     }
  //         // created_date in 2 weeks
  //   },
  // {
  //   auth: true,
  //   key: 'replenished', attribute: {
  //     "stock": {
  //       "replenished": true
  //     }
  //   }
  // }
]);
const getProducts = async () => {
  const promises = []

  // Personalized "Recommended for you" (auth only). Not cached in the shared
  // welcomProducts Redis key — it is per-customer.
  if (isAuthenticated.value) {
    promises.push(productStore.fetchRecommendedProducts({
      selectedLanguage: selectedLanguage.value,
    }));
  }

  for (let i = 0; i < keys.value.length; i++) {
    promises.push(productStore.fetchWelcomeProductsWithFilters({
      selectedLanguage: selectedLanguage.value,
      attribute: keys.value[i].attribute,
      categories: keys.value[i].categories,
      key: keys.value[i].key,
      range: 16, // Reduced from 32 to decrease DOM size and improve TBT
      sortOrder: keys.value[i].sort // Add custom sort if provided, otherwise defaults to stock_desc
    }));
  }
  await Promise.all(promises.map(async (p) => await p));
  productStore.setWelcomeProductsToRedis()

};

onBeforeMount(() => {
  productStore.refillWelcomeProductsFromRedis()
})
onMounted(() => {
  setTimeout(() => {
    getProducts().then(() => {
      console.log('products fetched')
     // productStore.handleWelcomeProductsBackOrders();
    });
  }, 0);

});

</script>

<template>
  <div class="container mx-auto px-4 mt-4">
    <WelcomeProducts
      v-if="recommendedProducts.length"
      id="product-container"
      class="grid grid-cols-1"
      :products="recommendedProducts"
      :attribute="{}"
      :category="[]"
      :expandedCategoryFilters="null"
      :categoryfilterState="null"
      key="recommended_for_you"
      att_key="recommended_for_you"
      kicker="recommended_kicker"
      description="recommended_desc"
      :highlight="true"
      :linkByIds="true"
      :backOrders="backOrders"
      :sort="null"
    />
    <div v-for="(k, index) in keys" :key="index">
      <WelcomeProducts
        v-if="products[k.key] && products[k.key]?.length"
        id="product-container"
        class="grid grid-cols-1"
        :products="products[k.key]"
        :attribute="k.attribute"
        :category="k.categories"
        :expandedCategoryFilters="k.expandedCategoryFilters"
        :categoryfilterState="k.categoryfilterState"
        :key="k.key"
        :att_key="k.key"
        :backOrders="backOrders"
        :sort="k.sort"
      />
    </div>
  </div>
</template>

<style scoped>
/* Tailwind classes used - no custom CSS needed */
</style>
